import { GALLERY } from "../lib/data";
import Reveal from "./Reveal";

export default function Gallery() {
  return (
    <section id="galerie" data-testid="gallery-section" className="bg-slate-50 py-20 md:py-28 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <Reveal>
            <span className="overline">Sur le terrain</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Nos interventions
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-lg text-ink-soft">
              Un aperçu de nos chantiers d&apos;urgence, du diagnostic à la remise en état.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}>
              <div
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden rounded-2xl border border-slate-200 shadow-sm ${
                  i % 5 === 0 ? "aspect-square md:aspect-[4/5]" : "aspect-square"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.label}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <span className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {g.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
